const STORAGE_KEY = 'gr_pending_mailbox_assign';
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

/**
 * Persist inbox form across Stripe Checkout redirect (sessionStorage).
 */
export function savePendingMailboxAssign(payload) {
  if (!payload?.provider || !payload?.fqdn || !payload?.mailboxUsername) {
    return;
  }
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...payload, savedAt: Date.now() })
  );
}

export function loadPendingMailboxAssign() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (!data?.savedAt || Date.now() - data.savedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingMailboxAssign() {
  sessionStorage.removeItem(STORAGE_KEY);
}
